import { Box, Button, Center, Heading, Link, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { tradingNameParser } from "src/lib/utils";
import { ReviewCard } from "./ReviewCard";
import StarDisplay from "./StarDisplay";
import getDummyReviews from "../lib/getDummyReviews";

function sortByMostRecent(reviews) {
  if (!reviews) return;
  reviews.sort(function (a, b) {
    return b.time - a.time;
  });
  return reviews;
}

const InstallerReviewsCard = (installer) => {
  const useDummyDataInStaging = true;
  const [reviews, setReviews] = useState([]);
  const [google_review_score, setGoogleReviewScore] = useState(0);
  const [google_review_count, setGoogleReviewCount] = useState(0);

  const { google_profile_url, google_place_id, name } = installer;

  useEffect(() => {
    const getReviews = (placeId) => {
      if (process.env.NODE_ENV == "development" && useDummyDataInStaging) {
        return Promise.resolve(getDummyReviews()); // Ensure always returning a promise
      } else {
        return fetch(`/api/reviews?placeId=${placeId}`)
          .then((response) => response.json())
          .then((data) => ({
            reviews: data.reviews,
            rating: data.rating,
            totalReviews: data.totalReviews,
          }));
      }
    };

    getReviews(google_place_id).then((data) => {
      setReviews(data.reviews || []);
      setGoogleReviewScore(data.rating || null);
      setGoogleReviewCount(data.totalReviews || null);
    });
  }, [google_place_id, useDummyDataInStaging]);

  const sortedReviews = sortByMostRecent(reviews);

  return (
    <Box bg={"white"} borderWidth="1px" p={8} borderRadius={4} mb={8} pt={12}>
      {<StarDisplay stars={google_review_score} />}
      <Heading as="h2" size="md" mb={0} mt={2}>
        {google_review_count} Reviews for {tradingNameParser(name)}
      </Heading>
      {reviews ? (
        <>
          {sortedReviews &&
            sortedReviews.map((review, i) => (
              <ReviewCard
                review={review}
                key={review.time}
                lastReview={!reviews[i + 1]}
              />
            ))}
          {google_review_count > 5 && (
            <Center mt={8}>
              <Link href={google_profile_url} isExternal>
                <Button>{`View all ${google_review_count} reviews`}</Button>
              </Link>
            </Center>
          )}
        </>
      ) : (
        <>
          <Text>We have not found Google Reviews for {name} yet.</Text>
        </>
      )}
    </Box>
  );
};

export default InstallerReviewsCard;
